import React from "react";
import materialDetail from "../assets/material_detail.jpg";
import "./HowWeWork.css";

export default function HowWeWork() {
  return (
    <div className="hww-root">
      <section className="hww-hero" aria-labelledby="hww-title">
        <div className="hww-hero-media">
          <img
            src={materialDetail}
            alt="Interior material samples with wood, stone and hardware"
          />
        </div>

        <div className="hww-hero-overlay" />

        <div className="hww-wrap hww-hero-content">
          <p className="hww-eyebrow">How We Work</p>
          <h1 id="hww-title">
            Six careful steps from first conversation to finished home.
          </h1>
          <p>
            Dwellora keeps the design language, specialist execution and site
            coordination moving as one clear process, so every decision feels
            connected from concept to handover.
          </p>
          <a className="hww-hero-cta" href="/contact">
            Book a Consultation
          </a>
        </div>
      </section>

      <section className="hww-wrap hww-steps" aria-label="Dwellora work steps">
        <div className="hww-steps-list">
          <div className="hww-step">
            <span>01</span>
            <h2>Understand</h2>
            <p>
              A conversation about how you live, your family, timelines and a
              realistic budget band. We document the brief before designing.
            </p>
          </div>

          <div className="hww-step">
            <span>02</span>
            <h2>Design</h2>
            <p>
              Space planning, elevations, detailing and 3D visualisation.
              Clearly labelled as Design Concept until built.
            </p>
          </div>

          <div className="hww-step">
            <span>03</span>
            <h2>Finalize</h2>
            <p>
              Materials, finishes, hardware and appliances locked, with a
              transparent scope and package-wise costing.
            </p>
          </div>

          <div className="hww-step">
            <span>04</span>
            <h2>Match Specialists</h2>
            <p>
              Work is divided into packages - kitchen, wardrobe, sofa,
              electrical, civil, carpentry - and matched to the right maker.
            </p>
          </div>

          <div className="hww-step">
            <span>05</span>
            <h2>Coordinate</h2>
            <p>
              Dwellora sequences the site, runs quality checks at factory and
              site, and keeps one point of contact for you.
            </p>
          </div>

          <div className="hww-step">
            <span>06</span>
            <h2>Deliver</h2>
            <p>
              Installation, snagging, cleaning and handover of one cohesive
              interior, on one design language.
            </p>
          </div>
        </div>
      </section>

      <section className="hww-packages">
        <div className="hww-wrap hww-package-grid">
          <div className="hww-package-copy">
            <p className="hww-eyebrow">Work Packages</p>
            <h2>One interior, divided intelligently.</h2>
            <p>
              Each package is drawn by Dwellora and produced by a specialist,
              then integrated back into a single cohesive interior on site.
            </p>

            <div className="hww-package-list">
              <span>Modular Kitchen</span>
              <span>Wardrobes &amp; Storage</span>
              <span>Sofa &amp; Upholstery</span>
              <span>Loose Furniture</span>
              <span>Electrical &amp; Lighting</span>
              <span>Civil &amp; Plumbing</span>
              <span>Carpentry &amp; Panelling</span>
              <span>False Ceiling &amp; Painting</span>
            </div>
          </div>

          <div className="hww-package-image">
            <img
              src={materialDetail}
              alt="Interior material samples: wood veneer, stone, brass hardware and fabric swatches"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <section className="hww-wrap hww-cta-band">
        <h2>
          Idea - Design - Selection - Specialist Manufacturing - Coordination -
          Site - Installation - Finished Home.
        </h2>
        <a href="/contact">Book a Consultation</a>
      </section>
    </div>
  );
}
